export default __webpack_public_path__ + "static/media/Lori_Anne_Rising_AHV_In_Moms_We_Trust.cba433b5.jpg";